import { LicenseInfo } from '@mui/x-license';
import CommonProviders from 'CommonProviders';
import { StrictMode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { APP_ROUTES } from 'shared/constants';

import AppRoutes from './routes';

LicenseInfo.setLicenseKey('73b3e70d05a52e8cbec5547de94dc7b6Tz0xMTk3ODUsRT0xNzkyODg2Mzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=');

function App() {
    return (
        <StrictMode>
            <BrowserRouter basename={ APP_ROUTES.basename }>
                <CommonProviders>
                    <AppRoutes />
                </CommonProviders>
            </BrowserRouter>
        </StrictMode>
    );
}

export default App;
